<template>
	<div class="row dashboard-student-main">
		<!-- <div class="col-12">
			<b-alert class="mt-3" :show="!!profile.notification" variant="info">
				<div class="notification" v-html="profile.notification" />
			</b-alert>
		</div> -->

		<!-- <section class="section col-12 User">
			<div class="UserBlock block-white">
				<label class="UserBlockAvatar" for="avatar">
					<div class="avatar" :style="{ backgroundImage: 'url(' + profile.photo + ')' }">
						<span v-if="profile.photo === null" class="no-avatar">
							<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M16.4 3.34L13.66 0.6C13.3024 0.264096 12.8338 0.0713588 12.3433 0.058452C11.8529 0.0455453 11.3748 0.213369 11 0.53L1.99999 9.53C1.67676 9.85596 1.4755 10.2832 1.42999 10.74L0.999992 14.91C0.98652 15.0565 1.00553 15.2041 1.05565 15.3424C1.10578 15.4807 1.18579 15.6062 1.28999 15.71C1.38343 15.8027 1.49425 15.876 1.61609 15.9258C1.73792 15.9755 1.86838 16.0008 1.99999 16H2.08999L6.25999 15.62C6.71679 15.5745 7.14403 15.3732 7.46999 15.05L16.47 6.05C16.8193 5.68097 17.0081 5.18851 16.995 4.68054C16.9818 4.17256 16.7679 3.69051 16.4 3.34ZM6.07999 13.62L3.07999 13.9L3.34999 10.9L8.99999 5.32L11.7 8.02L6.07999 13.62ZM13 6.68L10.32 4L12.27 2L15 4.73L13 6.68Z"
									fill="#828282" />
							</svg>
						</span>
					</div>

					<input id="avatar" hidden v-if="!isReadOnly" type="file" accept="image/jpeg, image/png"
						@change="changeAvatar" />
				</label>
				<div class="UserBlockInfo">
					<h2 class="wrap-name">
						<span class="name">{{ profile.first_name }} {{ profile.last_name }}</span>
						<span class="role">
							<IconStudy />
							{{ capitalizeFirstLetter(profile.role) | translate }}
						</span>
					</h2>
					<p v-show="!isFree" class="birthday">
						<IconGift />
						<span class="birthdayDay">{{ profile.birthday }} </span>
						<span class="setting" @click="isReadOnly ? '' : (showModalBirthday = true)">
							<IconSetting />
						</span>
					</p>
				</div>
				<div class="UserBlockEnv">
					<div class="EnvItem UserBalance">
						<div class="container-balance">
							<div @click="showModalTransactionHistory = true">
								<strong>{{ 'Balance' | translate }}: </strong> <span>i$</span>
								<span>{{ profile.indigo_dollars }}</span>
							</div> -->
		<!-- <router-link class="btn-shop" to="/dashboard-student/shop">
								<IconShop />
								<span>{{ 'Shop' | translate }}</span>
							</router-link> -->
		<!-- </div>
					</div>
					<div class="EnvItem UserLang">
						<p class="UserLangRow" v-on:click="false">
							<strong>{{ 'Language' | translate }}:</strong> {{ lng() }}
							<span @click="isDropdownLng = !isDropdownLng" class="setting" ref="button">
								<IconSetting />
							</span>
							<a v-show="isDropdownLng" class="dropdownMy" @click="false">
								<span v-for="language in languages" :key="language" @click="changeLang(language)" class="dropdownMyItem"
									:class="Lng[language].name === lng() ? 'dropdownMyItemActive' : ''
										">
									{{ Lng[language].name }}
									<svg v-if="Lng[language].name === lng()" width="12" height="9" viewBox="0 0 12 9" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M4.57333 9C4.48192 8.99971 4.39154 8.98062 4.30782 8.94392C4.2241 8.90722 4.14882 8.85369 4.08666 8.78667L0.846663 5.34C0.725547 5.21093 0.660666 5.03903 0.666292 4.86212C0.671918 4.68521 0.747591 4.51778 0.876663 4.39667C1.00573 4.27555 1.17763 4.21067 1.35454 4.2163C1.53145 4.22192 1.69888 4.2976 1.82 4.42667L4.56666 7.35333L10.1733 1.22C10.2302 1.14915 10.301 1.09068 10.3813 1.04818C10.4616 1.00568 10.5498 0.980044 10.6404 0.972854C10.731 0.965665 10.8221 0.97707 10.9081 1.00637C10.9941 1.03567 11.0732 1.08224 11.1406 1.14323C11.2079 1.20422 11.2621 1.27834 11.2998 1.36103C11.3375 1.44372 11.3579 1.53324 11.3597 1.62409C11.3615 1.71495 11.3447 1.80521 11.3104 1.88934C11.276 1.97347 11.2249 2.0497 11.16 2.11333L5.06666 8.78C5.00509 8.84824 4.93007 8.90301 4.84632 8.94087C4.76257 8.97873 4.6719 8.99886 4.58 9H4.57333Z"
											fill="#00CE5F" />
									</svg>
								</span>
							</a>
						</p>
					</div>
				</div>
			</div> -->
		<!-- <div class="UserHomework block-white"> -->
		<!-- <div v-if="isReadOnly || $store.state.myProfile.role === 'student'">
					<router-link class="btn-homework" :to="homeworkLink">
						{{ 'Homework' | translate }}
					</router-link>
				</div> -->
		<!-- <div class="partners"> -->
		<!-- <a href="https://www.matific.com" target="_blank" class="partner">
						<img src="../../assets/partners/1.svg" alt="" />
					</a> -->
		<!-- <a href="https://student.smartreader.com.ua" target="_blank" class="partner">
						<img src="../../assets/partners/2.png" alt="" />
					</a>
				</div>
			</div> -->
		<!-- </section> -->
		<div class="col-12">
			<Learning :groups="translateGroups" />
		</div>
		<div class="section col-12">
			<div class="row">
				<div class="col-xl-3 col-lg-4">
					<h5>
						<i class="fa fa-bookmark" aria-hidden="true" />
						{{ 'History statistics' | translate }}
					</h5>
					<div class="inner text-center ">
						<div class="row align-items-center">
							<div class="col">
								<h4>{{ 'History statistics' | translate }}</h4>
								<img src="../../assets/list.png" alt="" />
								<router-link
									:to="
										Object.assign(
											{},
											{ name: 'Dashboard Student Statistic' },
											{ query: $route.query }
										)
									"
									class="btn btn-warning"
								>
									{{ 'Open' | translate }}
								</router-link>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-6 col-lg-4">
					<h5>
						<i class="fa fa-bar-chart" aria-hidden="true" />
						{{ 'Game statistics per day' | translate }}
					</h5>
					<div class="inner text-center ">
						<div class="row align-items-center">
							<div class="col">
								<h4>{{ statistic.today.total }}</h4>
								<h6>{{ 'Total played games' | translate }}</h6>
							</div>
							<div class="col">
								<h4>{{ statistic.today.right_answers }}</h4>
								<h6>{{ 'Total correct answers' | translate }}</h6>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-3 col-lg-4">
					<h5>
						<i class="fa fa-eye" aria-hidden="true" />
						{{ 'Total' | translate }}
					</h5>
					<div class="inner text-center">
						<h6>{{ 'Total played:' | translate }}</h6>
						<h4>{{ statistic.all_time.total }} {{ 'Games' | translate }}</h4>
						<table class="table">
							<tbody>
								<tr>
									<td>{{ 'match.column' | translate }}</td>
									<td>{{ statistic.all_time.columns || 0 }}</td>
								</tr>
								<tr>
									<td>{{ 'Speedy numbers' | translate }}</td>
									<td>{{ statistic.all_time.addition || 0 }}</td>
								</tr>
								<tr>
									<td>{{ 'Anzan' | translate }}</td>
									<td>{{ statistic.all_time.anzan || 0 }}</td>
								</tr>
								<tr>
									<td>{{ 'Abacus is random' | translate }}</td>
									<td>{{ statistic.all_time.abacus_random || 0 }}</td>
								</tr>
								<tr>
									<td>{{ 'Multiplication' | translate }}</td>
									<td>{{ statistic.all_time.multiply || 0 }}</td>
								</tr>
								<tr>
									<td>{{ 'Division' | translate }}</td>
									<td>{{ statistic.all_time.divide || 0 }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div v-if="false" class="section col-12">
			<h3>
				<i class="fa fa-commenting" aria-hidden="true" />
				{{ 'Feedback' | translate }}
			</h3>
			<p>
				<button
					class="btn btn-lg btn-warning"
					@click="isReadOnly ? '' : (showModalFeedback = true)"
				>
					{{ 'Leave a review' | translate }}
				</button>
				{{
					'Leave us your feedback or wishes and we will definitely consider them in our work.'
						| translate
				}}
			</p>
		</div>
		<!-- <ModalBirthday :show="showModalBirthday" @close="showModalBirthday = false" />
		<ModalTransactionsHistory :id="profile.id" :show="showModalTransactionHistory"
			@close="showModalTransactionHistory = false" /> -->
	</div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$color-orange: #ffc73b;
$color-gray-light: #f2f2f2;
$color-gray: #828282;
$color-gray-dark: #4f4f4f;
$color-pink: #fa0b76;
$color-yellow: #ffd210;

.dashboard-student-main {
	@media (min-width: 1300px) {
		width: 80%;

		margin-right: auto !important;
		margin-left: 8% !important;

		transform: scale(0.9);
		transform-origin: top left;
	}

	@media (min-width: 1300px) and (max-width: 1600px) {
		& table td {
			padding: 10px 5px;
		}
	}
}

.notification img {
	width: 100% !important;
}

.container-balance {
	padding-top: 5px;
	display: flex;
	align-items: center;

	@media (max-width: 1200px) {
		flex-direction: column;
		align-items: flex-start;
	}

	span {
		margin-left: 3px;
	}
}

.wrap-name {
	font-weight: bold;
	font-size: 24px;
	display: flex;
	align-items: flex-start;
	margin-right: 20px;
	line-height: 140%;

	@media (max-width: 1200px) {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}
}

.name {
	max-width: 280px;
	word-wrap: break-word;
	white-space: pre-wrap;
	/* CSS3 */
	white-space: -moz-pre-wrap;
	/* Firefox */
	white-space: -pre-wrap;
	/* Opera <7 */
	white-space: -o-pre-wrap;
	/* Opera 7 */
	word-wrap: break-word;
	/* IE */
}

.balance {
	font-size: 36px;
}

.btn-shop {
	margin-left: 14px;
	background-color: $color-orange;
	color: #ffff;
	font-weight: normal;
	font-size: 12px;
	width: 82px;
	display: flex;
	justify-content: center;
	align-items: center;
	//height: 24px;
	cursor: pointer;
	line-height: 24px;
	border-radius: 4px;

	@media (max-width: 1200px) {
		margin-left: 0;
		margin-bottom: 10px;
	}

	svg {
		flex-shrink: 0;
		margin-right: 4px;
	}

	&:hover {
		color: #fff;
		text-decoration: none;
	}
}

.birthday {
	display: flex;
	align-items: center;

	&Day {
		margin: 0 5px;
		color: $color-gray;
	}

	span {
		margin: 0 5px;

		color: $color-gray;
	}
}

.setting {
	position: relative;
	width: 24px;
	height: 24px;
	border-radius: 10em;
	background-color: $color-gray-light;
	transition: background-color 0.35s ease-in-out;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;

	svg path {
		fill: $color-gray;
		transition: fill 0.35s ease-in-out;
	}

	&:hover {
		background-color: $color-gray-dark;

		svg path {
			fill: #fff;
		}
	}
}

.role {
	color: $color-pink;
	padding: 5px 9px;
	background-color: transparent;
	font-weight: normal;
	font-size: 12px;
	line-height: 140%;
	border: 1px solid $color-pink;
	border-radius: 12px;
	margin-left: 14px;
	flex-shrink: 0;

	@media (max-width: 1200px) {
		margin-left: 0;
	}

	svg {
		margin-right: 4px;

		path {
			fill: $color-pink;
		}
	}
}

.dropdownMy {
	background-color: #fff;
	display: flex;
	flex-direction: column;
	position: absolute !important;
	width: 144px;
	z-index: 1;
	box-shadow: 0 4px 16px rgba(230, 233, 243, 0.8);
	border-radius: 8px;
	padding: 14px 0;
	top: 30px;
	left: 70px;

	&Item {
		padding: 4px 12px;
		font-weight: normal;
		font-size: 16px;
		line-height: 140%;
		display: flex;
		justify-content: space-between;

		&Active {
			font-weight: bold;
		}
	}
}

.personal img {
	width: 80px;
	height: 80px;
	border-radius: 50%;
}

.header {
	background-color: #fff;
	margin: 10px;
	border-radius: 5px;
	padding: 20px;
	border: 1px solid #e2e7eb;
}

// .User {
// 	display: flex;
// 	flex: 1;

// 	@media (max-width: 1200px) {
// 		flex-direction: column;
// 	}

// 	&Lang {
// 		&Row {
// 			position: relative;
// 			margin-top: 10px;
// 		}
// 	}

// 	&Block {
// 		flex: 3;
// 		margin-right: 30px;
// 		display: flex;

// 		@media (max-width: 1220px) {
// 			margin-right: 0;
// 		}

// 		@media (max-width: 480px) {
// 			display: grid;
// 			grid-template-areas:
// 				'avatar info'
// 				'. env';
// 		}

// 		&Avatar {
// 			grid-area: avatar;

// 			@media (max-width: 1200px) {
// 				flex: 2;
// 			}

// 			flex: 1;
// 		}

// 		&Info {
// 			grid-area: info;

// 			flex: 3;

// 			@media (max-width: 1200px) {
// 				flex: 4;
// 			}
// 		}

// 		&Env {
// 			grid-area: env;
// 			margin-left: 20px;

// 			flex: 3;

// 			@media (max-width: 480px) {
// 				margin-left: 0;
// 			}
// 		}
// 	}

// 	&Homework {
// 		width: 275px;

// 		@media (max-width: 1200px) {
// 			justify-content: center;
// 			align-items: center;
// 			display: flex;
// 			flex-direction: column;
// 			margin-top: 20px;
// 			width: auto;
// 			flex: 1;
// 		}
// 	}
// }

.partners {
	display: flex;
	margin-top: 24px;
}

.partner {
	flex: 1;
	margin-right: 15px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 4px 10px;

	img {
		width: 100%;
	}

	&:last-child {
		margin-right: 0;
	}
}

.btn-homework {
	width: 100%;
	height: 46px;
	display: flex;
	background-color: $color-yellow;
	color: #fff;
	justify-content: center;
	align-items: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
	border-radius: 8px;
	font-weight: bold;
	font-size: 16px;
	line-height: 140%;

	@media (max-width: 1200px) {
		width: 250px;
	}

	&:hover {
		text-decoration: none;
		color: #fff;
	}
}

.avatar {
	width: 80px;
	height: 80px;
	background-position: center;
	background-size: cover;
	display: inline-block;
	border-radius: 50%;
	cursor: pointer;
}

.avatar-block input[type='file'] {
	position: absolute;
	width: 80px;
	height: 80px;
	top: 0;
	left: 15px;
	cursor: pointer;
	opacity: 0;
}

.block-white {
	background-color: #fff;
	padding: 24px 32px;
}

.no-avatar {
	background: #f2f2f2;
	border-radius: 10em;
	width: 80px;
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.section {
	padding: 40px 30px;
}

.inner {
	background-color: #fff;
	border-radius: 5px;
	border: 1px solid #e2e7eb;
	padding: 20px;
	height: 380px;
}

.inner .row {
	height: 100%;
}

.inner img {
	display: inline-block;
	margin-top: 30px;
	margin-bottom: 30px;
}

.inner .btn-warning {
	width: 100%;
	font-size: 20px;
	margin-top: 10px;
}

@media (max-width: 575px) {
	.header,
	.header .text-right {
		text-align: center !important;
	}
}

@media (min-width: 576px) and (max-width: 767px) {
}

@media (max-width: 991px) {
	h5 {
		margin-top: 30px;
	}
}

@media (min-width: 992px) and (max-width: 1199px) {
	h5 {
		font-size: 19px;
	}
}
</style>

<script>
import Vue from 'vue'
import ModalBirthday from './Modal/Birthday.vue'
import ModalTransactionsHistory from '@/containers/Modals/TransactionsHistory.vue'
import IconSetting from '@/components/svg/IconSetting'
import IconGift from '@/components/svg/IconGift'
import IconShop from '@/components/svg/IconShop'
import IconStudy from '@/components/svg/IconStudy'
import Learning from '@/components/DashboardStudent/Learning'

let handleOutsideClick
Vue.directive('closable', {
	bind(el, binding, vnode) {
		handleOutsideClick = e => {
			e && e.stopPropagation()
			let clickedOnExcludedEl = false
			binding &&
				binding.value &&
				binding.value.exclude &&
				binding.value.exclude.forEach(refName => {
					if (!clickedOnExcludedEl) {
						const excludedEl =
							vnode &&
							vnode.context &&
							vnode.context.$refs &&
							vnode.context.$refs[refName]
						clickedOnExcludedEl = excludedEl && excludedEl.contains(e.target)
					}
				})
			if (
				!el.contains(e.target) &&
				!clickedOnExcludedEl &&
				binding &&
				binding.value &&
				binding.value.handler
			) {
				vnode.context[binding.value.handler] &&
					vnode.context[binding.value.handler]()
			}
		}
		document.addEventListener('click', handleOutsideClick)
		document.addEventListener('touchstart', handleOutsideClick)
	},

	unbind() {
		document.removeEventListener('click', handleOutsideClick)
		document.removeEventListener('touchstart', handleOutsideClick)
	},
})

export default {
	name: 'Main',
	data() {
		return {
			isFree: JSON.parse(localStorage.getItem('userProfile'))?.is_free,
			Lng: {
				en: { name: 'English' },
				ru: { name: 'Русский' },
				ua: { name: 'Українська' },
				pl: { name: 'Polski' },
				he: { name: 'עברית' },
				az: { name: 'Azərbaycan' },
				hy: { name: 'հայերեն' },
				ro: { name: 'Română' },
				fr: { name: 'Français' },
				es: { name: 'Español' },
				cs: { name: 'Czech' },
				it: { name: 'Italiano' },
				tr: { name: 'Türkçe' },
				el: { name: 'Ελληνικά' },
			},
			languages: [
				'en',
				'ru',
				'ua',
				'pl',
				'he',
				'az',
				'hy',
				'ro',
				'fr',
				'es',
				'cs',
				'de',
				'it',
				'tr',
				'el',
			],
			groups: [],
			showModalBirthday: false,
			showModalFeedback: false,
			showModalTransactionHistory: false,
			showNav: false,
			isDropdownLng: false,
			statistic: {
				today: {
					total: 0,
					right_answers: 0,
				},
				all_time: {
					total: 0,
				},
			},
		}
	},
	components: {
		// IconSetting,
		// IconGift,
		// IconShop,
		// IconStudy,
		Learning,
		// ModalTransactionsHistory,
		// ModalBirthday,
	},
	computed: {
		homeworkLink() {
			let link = { name: 'Dashboard Student Homework', query: {} }
			if (this.$route.query.read_only !== undefined) {
				link.query.read_only = this.$route.query.read_only
			}
			return link
		},
		profile() {
			return this.$route.query.read_only !== undefined
				? this.$store.state.profile
				: this.$store.state.myProfile
		},
		isReadOnly() {
			return this.$route.query.read_only !== undefined
		},
		translateGroups() {
			let groups = this.groups
			let lang = this.$i18n.locale()
			if (lang === 'ua') {
				lang = 'uk'
			}
			groups.forEach(group => {
				group.name = group[`name_${lang}`]
				group.lessons.forEach(lesson => {
					lesson.name = lesson[`name_${lang}`]
				})
			})
			return groups
		},
	},
	methods: {
		onClose() {
			this.isDropdownLng = false
		},
		lng() {
			const item = localStorage.getItem('defaultLanguage')
			return this.Lng[item] && this.Lng[item].name
		},
		changeLang(locale) {
			window.localStorage.setItem('defaultLanguage', locale)
			this.isDropdownLng = !this.isDropdownLng

			this.$i18n.set(locale)
		},
		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1)
		},
		changeAvatar(e) {
			let files = e.target.files

			// console.log(files[0].type)

			if (files[0].type != 'image/jpeg' && files[0].type != 'image/png') {
				console.log('incorrect file format')

				return
			}

			let photo = new FormData()
			for (var i = 0; i < files.length; i++) {
				let file = files.item(i)
				photo.append(file.name, file, file.name)
			}
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}

			return this.axios
				.post(
					`users/user/${this.$store.state.myProfile.id}/avatar`,
					photo,
					config
				)
				.then(response => {
					let myProfile = this.$store.state.myProfile
					myProfile.photo = response.data.photo
					window.localStorage.setItem('userProfile', JSON.stringify(myProfile))
				})
		},
		async getLessons() {
			try {
				const result = await this.axios({
					method: 'get',
					url: `lessons/grouped?user=${this.$route.query.read_only ||
						this.$store.state.myProfile.id}`,
				})
				this.groups = result.data.groups
			} catch (e) {}
		},
		async getStatistic() {
			let now = new Date()
			let day = now.getDate()
			let month = now.getMonth() + 1
			let year = now.getFullYear()

			try {
				this.axios({
					method: 'get',
					url: `lessons/game/data/statistic?day=${day}&month=${month}&year=${year}&user=${this
						.$route.query.read_only || this.$store.state.myProfile.id}`,
				}).then(response => {
					this.statistic = response.data

					localStorage.setItem('totalPlayed', response?.data?.all_time?.total)
					localStorage.setItem(
						'totalRight',
						response?.data?.all_time?.total_right
					)
				})
			} catch (e) {}
		},
	},
	created() {
		this.getLessons()
		this.getStatistic()
	},
}
</script>
